import { MutationTree } from 'vuex';
import { TagsState } from '../types';
import { decodeTags } from '@/utils/decoding';
import Vue from 'vue';

export const mutations: MutationTree<TagsState> = {

	/**
	 * Set all tags
	 */
	SET_TAGS(state, tags: MenuItemTag[]) {
		Vue.set(state, 'tags', decodeTags(tags));
	}
};
